import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-page-header',
  standalone: true,
  template: `
    <div class="module-header">
      <h2 class="module-header__title">{{ title }}</h2>
      @if (subtitle) {
        <p class="module-header__subtitle">{{ subtitle }}</p>
      }
    </div>
  `,
})
export class PageHeader {
  @Input({ required: true }) title = '';
  @Input() subtitle = '';
}
